/**
 * Shared feature-flag parsing used by all clients.
 */
export function parseFeatureFlag(value: string | undefined): boolean {
  return !!value && ["true", "1", "yes", "on", "enabled"].includes(value.toLowerCase());
}
